import IO from "./io";
import { ATGSagas } from "./ATG";
import {InvoiceSagas} from "./Invoice"

export default [
    ...IO,
    ...ATGSagas,
    ...InvoiceSagas
];
